import Axios from "axios";
let { content } = document.head.querySelector('meta[name="csrf-token"]');
export default Axios.create({
    baseURL: '/wapi/0/',
    timeout: 30000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': content
    },
    validateStatus: (status => {
        return (status >= 200 && status < 300) || status === 422 || status === 429 || status == 450 || status == 405 || status == 404 || status === 400;
    })
});
